import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { atendimentoEndpoint, type AtendimentoVenda, type SituacaoFiltro } from '../types';

type Input = { slug: string; situacao?: SituacaoFiltro };

// Vendas do atendimento assistido do dia (mais recentes primeiro).
export class ListPedidosAtendimentoUseCase implements IUseCase<Input, AtendimentoVenda[]> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug, situacao = 'todos' }: Input): Promise<AtendimentoVenda[]> {
    const response = await this.client.sendRequest<{ data: AtendimentoVenda[] }, never>({
      endpoint: `${atendimentoEndpoint(slug)}/pedidos`,
      method: HttpMethod.GET,
      params: { situacao },
    });

    return response.data ?? [];
  }

  // "Meus pedidos" do cliente no autoatendimento desta loja (token do cliente,
  // últimos 30 dias). Fica aqui para não sair do atendimento para o histórico
  // do app (`/orders`).
  async meusPedidos({ slug }: { slug: string }): Promise<AtendimentoVenda[]> {
    const response = await this.client.sendRequest<{ data: AtendimentoVenda[] }, never>({
      endpoint: `${atendimentoEndpoint(slug)}/meus-pedidos`,
      method: HttpMethod.GET,
    });

    return response.data ?? [];
  }
}
